module.exports = {
    name:      "backgammon",
    buildDate: "Wed Apr 03 2019 18:13:01 GMT+0300 (MSK)",
    version:   "1.0.0",
    build:     "5.00 debug"
};



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 6
// module chunks = 0